<section class="mt-5" *ngIf="commonService.commonMainObj.invalidUser && commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">
    <div class="vh_center mt-4">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_er.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
    </div>
    <div class="vh_center mt-2">
        <div col="12">
          <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Save Quote</div>
          </div>
        </div>
    </div>
    <div class="text-center text-danger fw-b mt-5 fs-2">Sorry, this quote cannot be saved.</div>
    <div class="text-center mt-4">
      Quote <b>{{commonService.commonMainObj.wqId}} </b> was generated with <b> {{commonService.commonMainObj.email}} </b> but you have signed in with <b> {{commonService.commonMainObj.loginEmail}} </b>
    </div>
    <div class="text-center mt-4">
      <p>
        Please restart the flow by clicking on ‘OK’ button and make sure to sign-in with the email id that was used to generate the quote.
      </p>
    </div>
    <div class="text-center mt-4">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Ok</b>
      </button>
    </div>
</section>
<div id="guestSaveQuoteProcess" class="mb-5">
    <div class="vh_center mt-4">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
    </div>
    <div class="vh_center mt-2">
        <div col="12">
          <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 30px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Quote</div>
            <div style="width:175px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request Custom Quote</div>
            <div style="width:150px;  padding-left: 20px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Quote</div>
            <div style="width:150px; padding-left: 15px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</div>
          </div>
        </div>
    </div>
    <div class="row mt-5 container-fluid mb-5">
        <div class="fs-3 mt-5 text-center"><span *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Processing your request,</span><span *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Saving your quote,</span> please wait…</div>
        <div class="progress m-3" style="--bs-progress-bar-bg: #fcb814 !important;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-label="Example with label" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</div>

<!-- OFP-338 -->
<div class="container-fluid border-0" id="saveQuoteSuccessData" *ngIf="!commonService.commonMainObj.invalidUser">
    <div class="vh_center mt-4" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
    </div>
    <div class="vh_center mt-2" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage">
        <div col="12">
            <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 20px; background-color: #ffffff;">Quote</div>
            <div style="width:150px; padding-left: 15px;  background-color: #ffffff;">Save Quote</div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-8 text-center succ-div" style="margin-bottom:1rem !important;" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl">
            <h2 style="color:#db9e0a;font-weight:600;">Your Quote is successfully saved!</h2>
            <p class="mt-3 fw-b">Your Quote Number is <span style="color:#db9e0a;font-weight:600 ;">{{commonService.commonMainObj.wqId}}</span>. To access the saved quote, please click <a href="{{commonService.commonMainObj.saveQuoteAccessUrl}}"  target="_blank" style="color:#db9e0a;font-weight:600 ;">SPX{{commonService.commonMainObj.spx}}</a></p>
        </div>
        <div class="col-8 text-center succ-div" style="margin-bottom:1rem !important;"  *ngIf="commonService.commonMainObj.saveQuoteMessage">
            <h2 style="color:red;font-weight:600;">Your Quote could not be saved!!</h2>
            <p class="mt-3 fw-b"><span style="color:#db9e0a;font-weight:600 ;">{{fisrtSavedMessageText}}</span> {{remainingSaveQuoteSentence}}</p>
        </div>
    </div>
    <div class="text-center">
        <button type="button" class="btn btn-custom mb-4 mt-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" *ngIf="commonService.commonMainObj.saveQuoteAccessUrl || commonService.commonMainObj.saveQuoteMessage" (click)="commonService.goBack()"> <b>Back to Home</b>
        </button>
    </div>
</div>


<div class="container-fluid border-0" *ngIf="commonService.commonMainObj.rNumber">
    <div class="vh_center mt-4">
        <div col="12">
            <div style=" margin:0px; " class="vh_center">
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
                <div style="width:130px; height:5px; background-color: #fcb816;"></div>
                <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
            </div>
        </div>
    </div>
    <div class="vh_center mt-2">
        <div col="12">
          <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
            <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
            <div style="width:150px;  padding-left: 30px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Quote</div>
            <div style="width:175px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'">Request Custom Quote</div>
            <div style="width:150px;  padding-left: 20px; background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Quote</div>
            <div style="width:150px; padding-left: 0px;  background-color: #ffffff;" *ngIf="commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'">Save Quote</div>
          </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-8 text-center succ-div">
            <h2 style="color:#db9e0a;font-weight:600;">Your request for custom quote is accepted!</h2>
            <!-- <h5>Someone from our sales team will contact you shortly.</h5> -->
            <h5 class="mt-3 fw-b">Your Request Number is <span style="color:#db9e0a;font-weight:600 ;">{{commonService.commonMainObj.rNumber}}</span></h5>
            <div class="mt-3">Your account manager will contact you shortly.</div>
            <div>Once the request is reviewed and the quote is generated, you can view the quote and place the order from <b><a target="_blank" href="{{commonService.commonMainObj.spxLink}}">{{commonService.commonMainObj.spxNumber}}</a></b>.</div>
            <div class="mt-3 fw-b">Account Manager Details:</div>
            <!-- <div class="row justify-content-center">
                <div class="col-6">
                    <div class="row justify-content-center">
                        <div class="col-4">Name: </div>
                        <div class="col-6">{{commonService.commonMainObj.accountManagerName}}</div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-6">
                    <div class="row justify-content-center">
                        <div class="col-4">Email Id: </div>
                        <div class="col-6">{{commonService.commonMainObj.accountManagerEmail}}</div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-6">
                    <div class="row justify-content-center">
                        <div class="col-4">Phone: </div>
                        <div class="col-6">{{commonService.commonMainObj.accountManagerPhone}}</div>
                    </div>
                </div>
            </div> -->
            <div><b>Name : </b><span> {{commonService.commonMainObj.accountManagerName}}</span></div>
            <div><b>Email Id : </b><a class="ofp-link" href="mailto: {{commonService.commonMainObj.accountManagerEmail}}"> {{commonService.commonMainObj.accountManagerEmail}}</a></div>
            <div><b>Contact Number : </b><a class="ofp-link" href="tel: {{commonService.commonMainObj.accountManagerPhone}}"> {{commonService.commonMainObj.accountManagerPhone}}</a></div>
            
        </div>
    </div>
    <div class="text-center">
        <button type="button" class="btn btn-custom mb-4 mt-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" *ngIf="commonService.commonMainObj.rNumber" (click)="commonService.goBack()"> <b>Back to Home</b>
        </button>
    </div>
</div>